import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { buyers, images } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(-1);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const delay = visible ? VISIBLE_FOR : index === -1 ? FIRST_DELAY : GAP;
    const timer = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
      } else {
        setIndex(i => (i + 1) % buyers.length);
        setVisible(true);
      }
    }, delay);
    return () => window.clearTimeout(timer);
  }, [visible, index]);
  const buyer = index >= 0 ? buyers[index] : null;
  const minutesAgo = Math.max(index, 0) * 7 % 13 + 2;
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-28 sm:left-5 sm:right-auto" data-id="element-81" data-mp="1gz70gx1yv6zh">
      <AnimatePresence data-id="element-82" data-mp="165h7ehi1xj06">
        {visible && buyer && <motion.div key={index} role="status" initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_20px_40px_-12px_rgba(6,18,42,0.4)] ring-1 ring-black/5 sm:w-[340px]" data-id="element-83" data-mp="163wcurvqm02b">
            <img src={images.mockup} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-mist object-contain" data-id="element-84" data-mp="ia4vatpl7mhp" />
            <div className="min-w-0" data-id="element-85" data-mp="s5evdbwfdjsu">
              <p className="truncate text-sm font-bold text-ink" data-id="element-86" data-mp="s8kl8tcvoppm">
                {buyer.name} · {buyer.country}
              </p>
              <p className="text-[13px] leading-snug text-muted" data-id="element-87" data-mp="23lwigle4ua2t">
                just purchased the <span className="font-semibold text-navy-800" data-id="element-88" data-mp="2aotjgaybbrh3">ECG Interpretation Blueprint™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-medium text-heal" data-id="element-89" data-mp="2fn4qyf14xpw5">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-90" data-mp="2km7oleesctu3" />
                {buyer.city} · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setVisible(false)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-mist hover:text-ink" aria-label="Dismiss notification" data-id="element-91" data-mp="2pjrbt3tgogy6">
              <XIcon className="h-4 w-4" data-id="element-92" data-mp="21u6gdlg4fr80" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}